import React from 'react';
import './ModalFormField.css';

export interface ModalFormFieldProps {
  id?: string;
  label?: React.ReactNode;
  required?: boolean;
  error?: string | null;
  hint?: React.ReactNode;
  className?: string;
  children: React.ReactNode;
}

const ModalFormField: React.FC<ModalFormFieldProps> = ({
  id,
  label,
  required = false,
  error,
  hint,
  className = '',
  children,
}) => (
  <div
    className={`modal-form-field${error ? ' modal-form-field--invalid' : ''}${className ? ` ${className}` : ''}`}
    id={id}
  >
    {label ? (
      <label className="modal-form-field__label" htmlFor={id}>
        {label}
        {required ? <span className="modal-form-field__required"> *</span> : null}
      </label>
    ) : null}
    {children}
    {error ? (
      <p className="modal-form-field__error" id={id ? `${id}-error` : undefined} role="alert">
        {error}
      </p>
    ) : hint ? (
      <p className="modal-form-field__hint">{hint}</p>
    ) : null}
  </div>
);

export default ModalFormField;
